// extracted by mini-css-extract-plugin
module.exports = {"Muted":"ManagerFlightBooking_Muted__37CS-","Strong":"ManagerFlightBooking_Strong__krnk0","Flag":"ManagerFlightBooking_Flag__3wBKa"};